import { render } from "./orgToUser.vue?vue&type=template&id=6f3ae7b3"
import script from "./orgToUser.vue?vue&type=script&lang=js"
export * from "./orgToUser.vue?vue&type=script&lang=js"

import "./orgToUser.vue?vue&type=style&index=0&id=6f3ae7b3&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__